<template>
    <div class="searchResult">
        <div class="title">
            <van-nav-bar :title="'处方记录(' + total + ')'"
                         left-arrow
                         @click-left="onClickLeft" />

        </div>
        <div class="search-box">
            <van-search v-model="patientNameValue"
                        placeholder="搜索患者姓名"
                        shape="round"
                        @input="debouncePatientName">
            </van-search>
            <span @click="clickFilter"
                  class="filter"
                  :class="{'filterActive':searchCallObj}"
                  ><van-icon name="filter-o" />筛选</span>
        </div>
        <div v-if="isSearching"
             class="list_conts">
            <div style="margin-top:80px"
                 v-if="!searchPreList.length">
                <!-- 搜索提示 -->
                <van-empty image="search"
                           description="暂无数据" />
            </div>
            <div v-else>
                <!-- :immediate-check="true" -->
                <van-list @load="getSearchPreList"
                          v-model="searchQueryParams.loading"
                          :finished="searchQueryParams.finished"
                          finished-text="没有更多了">
                    <ul v-for="(item,index) in searchPreList"
                        :key="index"
                        class="list_cont"
                        @click="goPreDetail(item)">
                        <li>{{item.inquiryName}}</li>
                        <li>
                            <span>
                                <span>{{ item.patientName }}</span><span>{{ sexTrans( item.patientSex) }}
                                    {{ item.patientUnifiedAag ? item.patientUnifiedAag : item.patientAge }}</span>
                            </span>
                            <!-- 全部 -->
                            <span
                                  :class="fetchStatus(item.status, item.auditStatus).className">{{ fetchStatus(item.status, item.auditStatus).value }}</span>
                        </li>
                        <li>
                            <span>诊断结果:</span>
                            <span>{{ item.diagnosis }}</span>
                        </li>
                        <li>
                            <span>医生信息:</span>
                            <span>{{ item.physicianName }}</span>
                        </li>
                        <li>
                            <span>问诊时间:</span>
                            <span>{{ item.inquiryReportTimeStr }}</span>
                        </li>
                    </ul>
                </van-list>
            </div>
        </div>
        <div v-else>
            <van-tabs ref="tables"
                      v-model="active"
                      class="tables"
                      title-active-color="#01B956"
                      color="#01B956"
                      line-height="3px"
                      line-width="30px"
                      title-inactive-color="#666"
                      @click="getTypeDate">
                <van-tab v-for="tabItem in tabNameList"
                         :key="tabItem.name"
                         :title="tabItem.title"
                         :name="tabItem.index">
                    <div class="list_conts">
                        <van-list v-model="loading"
                                  :finished="finished"
                                  :immediate-check="false"
                                  finished-text="已加载完全部数据"
                                  @load="onLoadList">
                            <div class="allinquiry">
                                <div class="allinquiry-tags">
                                    <van-tag v-for="(item, index) in tags"
                                             :key="index"
                                             :plain="selectedTag !== item.value"
                                             type="primary"
                                             round
                                             @click="tagSelect(item.value)">
                                        {{ item.label }}
                                    </van-tag>
                                </div>
                                <!--              <div class="prescription-num">-->
                                <!--                <span>{{ tabItem.index | titleText }}：</span>-->
                                <!--                <span>{{ total }}</span>-->
                                <!--              </div>-->
                            </div>
                            <ul v-for="(item,index) in list"
                                :key="index"
                                class="list_cont"
                                @click="goPreDetail(item)">
                                <!--              <li>{{ item.source === 3 ? '扫码问诊' : '荷叶问诊' }}</li>-->
                                <li>{{item.inquiryName}}</li>
                                <li>
                                    <span>
                                        <span>{{ item.patientName }}</span><span>{{ sexTrans( item.patientSex) }}
                                            {{ item.patientUnifiedAag ? item.patientUnifiedAag : item.patientAge }}</span>
                                    </span>
                                    <!-- 全部 -->
                                    <span v-if="tabItem.index === 0"
                                          :class="fetchStatus(item.status, item.auditStatus).className">{{ fetchStatus(item.status, item.auditStatus).value }}</span>
                                    <!-- 其它 -->
                                    <span v-else>
                                        <b :class="tabItem.index | filterClassName"
                                           v-if="tabItem.index == 2">{{item.auditStatus == 5 ? "已完成" : "已通过"}}</b>
                                        <b :class="tabItem.index | filterClassName"
                                           v-else>{{tabItem.index | filterValue}}</b>
                                    </span>
                                    <!--                <span v-else :class="tabItem.index | filterClassName">{{tabItem.index | filterValue}}</span>-->
                                </li>
                                <li>
                                    <span>诊断结果:</span>
                                    <span>{{ item.diagnosis }}</span>
                                </li>
                                <li>
                                    <span>医生信息:</span>
                                    <span>{{ item.physicianName }}</span>
                                </li>
                                <li>
                                    <span>问诊时间:</span>
                                    <span>{{ item.inquiryReportTimeStr }}</span>
                                </li>
                            </ul>
                        </van-list>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
        <div>
            <PFilterType :isShow.sync="isShowPFilter"
                         @filterCallback="filterFun" />
        </div>
    </div>
</template>
<script>
import fetchStatus from './config';
import { getPreList } from '../../api/index';

import { debounce1 } from '@/utils/index'
import PFilterType from './components/PFilterType.vue'
export default {
    components: {
        PFilterType
    },
    data () {
        return {
            selectedTag: '',
            tags: [{
                value: '',
                label: '全部'
            }, {
                value: 3,
                label: '扫码问诊'
            }, {
                value: 0,
                label: '荷叶问诊'
            }, {
                value: 2,
                label: '极速问诊'
            }, {
                value: 4,
                label: '名医问诊'
            }],
            index: 0,
            tabNameList: [{
                index: 0,
                title: '全部'
            }, {
                index: 1,
                title: '待审核'
            }, {
                index: 2,
                title: '已完成'
            }, {
                index: 3,
                title: '已驳回'
            }],
            showStatus: 1,
            pageNum: 1, // 页码

            finished: false, // 数据全部加载完成
            loading: false, // 加载状态是否结束,为true表示正在加载中
            total: '', // 总处方数

            list: [],
            active: '0',
            fetchStatus: fetchStatus,

            patientNameValue: '',//搜索框患者姓名
            debouncePatientName: null,
            isShowPFilter: false,
            isSearching: false,
            searchPreList: [],
            searchCallObj: null,
            searchQueryParams: {
                pageNum: 1,
                pageSize: 5,
                loading: false,
                finished: false,
            },
        }
    },
    computed: {
        // 转换男女
        sexTrans () {
            return function (oldsex) {
                const sex = (oldsex === 1 ? '男' : '女')
                return sex
            }
        },
        // 转换status
        tranStatus () {
            return function (status) {
                let showStatus
                if (status === 0) {
                    showStatus = '0'
                    return showStatus
                } else if (status === 1) {
                    showStatus = '1'
                    return showStatus
                } else if (status === 2) {
                    showStatus = '2'
                    return showStatus
                } else if (status === 3) {
                    showStatus = '3'
                    return showStatus
                }
                // status=4时，和下边待审核重复，渲染待审核就可以
            }
        },
        // 转换auditStatus
        tranAuditStatus () {
            return function (auditStatus) {
                let showAuditStatus
                if (auditStatus) {
                    showAuditStatus = auditStatus
                    return showAuditStatus
                }
            }
        }
    },
    filters: {
        titleText (index) {
            const TEXTJSON = {
                0: '总处方数',
                1: '待审核数',
                2: '已通过数',
                3: '已驳回数'
            }
            return TEXTJSON[index];
        },
        filterClassName (index) {
            const JSON = {
                1: 'waitAudited',
                2: 'audited',
                3: 'auditFail'
            }
            return JSON[index]
        },
        filterValue (index) {
            const JSON = {
                1: '待审核',
                2: '已通过',
                3: '已驳回'
            }
            return JSON[index]
        }
    },
    mounted () {
        this.loading = true;
        this.onLoadList();

        this.debouncePatientName = debounce1(this.searchPatientName, 1000);//防抖 停顿1s就执行 
    },
    methods: {
        filterFun (searchObj) {
            this.searchPreList = [];
            this.searchQueryParams.pageNum = 1;
            if (!searchObj) {//重置
                // this.patientNameValue = '';
                this.isSearching = false;
                this.searchCallObj = null;
                this.getSearchPreList();
            } else {//搜索
                this.isSearching = true;
                this.searchCallObj = searchObj;
                this.getSearchPreList();
            }
        },
        searchPatientName () {
            this.patientNameValue ? this.isSearching = true : this.isSearching = false;
            this.searchQueryParams.pageNum = 1;
            this.searchPreList = [];
            this.getSearchPreList();
        },
        clickFilter () {
            this.isShowPFilter = true;
        },
        async getSearchPreList () {
            let searchParams = {};
            if (this.searchCallObj) {
                searchParams = {
                    inquiryReportStartTime: this.searchCallObj.inquiryReportStartTime && this.searchCallObj.inquiryReportStartTime + ' 00:00:00' || '',
                    inquiryReportEndTime: this.searchCallObj.inquiryReportEndTime && this.searchCallObj.inquiryReportEndTime + ' 59:59:59' || '',
                    inquiryReportTimeSearchType: this.searchCallObj.inquiryReportTimeSearchType || '',
                }
            }
            let params = {
                perfectMatchPatientName: this.patientNameValue,
                pageNum: this.searchQueryParams.pageNum,
                pageSize: this.searchQueryParams.pageSize,
                ...searchParams
            }
            try {
                const res = await getPreList(params)
                this.searchQueryParams.loading = false;
                if (res.list.length < this.searchQueryParams.pageSize) { //返回的数量小于想要返回的要求的pageSize数量 即停止加载
                    this.searchQueryParams.finished = true;
                } else {
                    this.searchQueryParams.finished = false;
                    this.searchQueryParams.pageNum++;
                }
                const inquiryList = res.list.map(item => {
                    if (item.type == 2) {
                        item.inquiryName = '极速问诊'
                    } else if (item.type == 4) {
                        item.inquiryName = '名医问诊'
                    } else {
                        item.source == 3 ? item.inquiryName = '扫码问诊' : item.inquiryName = '荷叶问诊'
                    }
                    return item
                })
                this.searchPreList = this.searchPreList.concat(inquiryList);
                this.total = res.total;
            } catch (error) {
                this.$toast(error.msg)
            }
        },
        /**
        * @description: 选中标签
        * @param {}
        * @return:
        */
        tagSelect (selectedIndex) {
            this.selectedTag = selectedIndex;
            this.getListData(this.index, selectedIndex);
        },
        /**
        * @description: tab 切换,数据重置
        * @param {}
        * @return:
        */
        getTypeDate (index) {
            this.getListData(index, '');
        },
        /**
        * @description: 获取数据list
        * @param {}
        * @return:
        */
        getListData (index, selectedIndex) {
            this.index = index;
            this.list = []
            this.pageNum = 1
            this.finished = false
            this.loading = true
            this.selectedTag = selectedIndex;
            this.onLoadList();
        },
        /**
        * @description: 跳转详情页
        * @param {}
        * @return:
        */
        goPreDetail (item) {
            // 已关闭单独跳转 关闭页面
            if (item.status === 2) {
                // let { ext, unPrescribeReason } = item;
                const {
                    patientName,
                    patientSex,
                    patientAge,
                    physicianName,
                    createTime,
                    allergySymptom,
                    allergySymptomExplain,
                    ext = {},
                    unPrescribeReason = [],
                    medicineType
                } = item

                // debugger
                this.$router.push({
                    name: 'preclose',
                    params: {
                        item: {
                            patientName,
                            patientSex,
                            patientAge,
                            physicianName,
                            createTime,
                            allergySymptom,
                            allergySymptomExplain,
                            ext,
                            unPrescribeReason,
                            medicineType
                        }
                    },
                    query: { guid: item.guid, type: 'record' }
                })
            } else {
                this.$router.push({
                    path: 'waitpre',
                    query: { guid: item.guid, type: 'record' }
                })
            }
        },
        /**
        * @description: 上拉加载列表
        * @param {}
        * @return:
        */
        async onLoadList () {
            console.log("this.loading", this.loading);
            if (!this.loading) return
            try {
                let params
                if (this.selectedTag == 2 || this.selectedTag == 4) {
                    params = {
                        pageNum: this.pageNum,
                        pageSize: 10,
                        type: this.selectedTag
                    }
                } else {
                    params = {
                        pageNum: this.pageNum,
                        pageSize: 10,
                        source: this.selectedTag
                    }
                }
                if (this.index > 0) {
                    params = Object.assign({}, params, {
                        auditStatus: this.index
                    })
                }
                const res = await getPreList(params)
                this.total = res.total
                // 全部状态
                this.list.push(...res.list)
                if (this.list.length && this.list) {
                    this.list.forEach((item) => {
                        if (item.type == 2) {
                            item.inquiryName = '极速问诊'
                        } else if (item.type == 4) {
                            item.inquiryName = '名医问诊'
                        } else {
                            item.source == 3 ? item.inquiryName = '扫码问诊' : item.inquiryName = '荷叶问诊'
                        }
                    })
                }
                this.loading = false
                if (res.hasNextPage) {
                    this.pageNum++
                } else {
                    this.finished = true
                }
            } catch (error) {
                console.error(error)
            }
        },
        /**
        * @description: 跳转到我的页面
        * @param {}
        * @return:
        */
        onClickLeft () {
            window.location.href = 'protocol://action/finish/'
        }
    }
}
</script>
<style lang="scss" scoped>
.searchResult {
    background: #f7f7f7;
    min-height: 100vh;
}
.searchResult /deep/.van-nav-bar {
    color: #666666;
    height: 64px;
}
.van-nav-bar .van-icon {
    color: #666666;
    width: 10px;
    height: 18px;
    vertical-align: super;
}
.van-nav-bar__title {
    font-family: 'Microsoft YaHei', 微软雅黑;
    font-size: 18px;
    font-weight: 550;
    color: rgba(51, 51, 51, 1);
    line-height: 64px;
}
.title {
    position: fixed;
    background: #fff;
    width: 375px;
    height: 64px;
    color: #666666;
    top: 0;
    z-index: 10;
}
.van-hairline--bottom::after {
    border-bottom-width: 0;
}
/* 选项卡设置 */
.item_cont {
    position: fixed;
    width: 375px;
    background: #fff;
    top: 64px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.content {
    list-style: none;
    display: flex;
    justify-content: space-around;
    width: 375px;
}
.content li {
    font-size: 15px;
    font-weight: 400;
    color: #666;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.active {
    border-bottom: 3px solid #007bff;
    color: #007bff;
}
.list_conts {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.list_cont:nth-of-type(1) {
    margin-top: 10px;
}
.list_conts .list_cont {
    width: 345px;
    border-radius: 14px;
    background: #ffffff;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.list_conts .list_cont li {
    margin-left: 15px;
    width: 320px;
    line-height: 25px;
}
.list_conts .list_cont li:nth-of-type(1) {
    font-size: 15px;
    font-weight: 500;
    padding: 10px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #ddd;
}
.list_conts .list_cont li span:nth-of-type(n + 1) {
    font-size: 15px;
    font-weight: 300;
}
.list_conts .list_cont li span:nth-of-type(5) {
    font-weight: 300;
    color: blue;
}
.list_conts .list_cont li:nth-of-type(2) {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}
.list_conts .list_cont li:nth-last-of-type(1) {
    margin-bottom: 12.5px;
}
/* 总处方数 */
.allinquiry {
    display: flex;
    justify-content: space-between;
}
.allinquiry .prescription-num span:nth-of-type(1) {
    font-size: 13px;
    color: #999;
    height: 17px;
}
.allinquiry .prescription-num span:nth-of-type(2) {
    font-size: 13px;
    color: #333;
    height: 17px;
    font-weight: 600;
}
.allinquiry .allinquiry-tags {
    width: 100%;
}
.allinquiry .allinquiry-tags span {
    margin-left: 7px;
    padding: 5px 8px;
    border: none !important;
    color: #01b956;
    background: #e5f1ff;
}
.allinquiry .allinquiry-tags .van-tag--plain::before {
    border: none !important;
}
.allinquiry .allinquiry-tags .van-tag--plain {
    color: #333333;
    background: #ffffff;
}
/* .allinquiry .allinquiry-tags .van-tag--primary{color:#01B956;background:#E5F1FF;} */
.allinquiry .allinquiry-tags span:first-child {
    margin-left: 0;
}
/* 调整文字样式 */
.list_conts .list_cont li:nth-of-type(2) span:nth-of-type(1) {
    font-size: 17px;
    font-weight: 600;
    color: #333;
    margin-right: 5px;
}
.list_conts
    .list_cont
    li:nth-of-type(2)
    span:nth-of-type(1)
    span:nth-of-type(2) {
    font-size: 12px;
    font-weight: 400;
    color: #999;
}
.list_conts .list_cont li:nth-of-type(n + 3) span:nth-of-type(1) {
    font-size: 15px;
    font-weight: 400;
    color: #999;
    margin-right: 5px;
}
.list_conts .list_cont li:nth-of-type(n + 3) span:nth-of-type(2) {
    font-size: 15px;
    font-weight: 400;
    color: #333;
}
/* 4种class样式 */
.waitInquiry {
    font-size: 15px;
    color: #ff0000;
    font-weight: 400;
}
.waitAudited {
    font-size: 15px;
    color: #007bff;
    font-weight: 300;
}
.audited {
    font-size: 15px;
    color: #67c23a;
    font-weight: 300;
}
.cancelled,
.closed,
.overTime,
.auditFail {
    font-size: 15px;
    color: #666666;
    font-weight: 300;
}

.search-box {
    padding: 12px 15px 10px 10px;
    margin-top: 64px;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /deep/ .van-search {
        width: 85%;
    }
    .filter {
        font-size: 16px;
        color: #67c23a;
        &.filterActive{
            color: green;
        }
    }
}

.tables {
    // top: 64px;
    overflow: hidden;
}
.van-tabs /deep/.van-tabs__wrap {
    // position: fixed;
    // z-index: 10;
    // height: 45px;
    // // top: 64px;
    // left: 0;
    // right: 0;
}
.van-tabs /deep/ .van-tabs__content {
    // margin-top: 45px;
    background: #f7f7f7;
}
.van-tabs /deep/ .van-ellipsis {
    font-size: 15px;
}
.tables[data-v-61e44a7a] {
    background: #f7f7f7;
}
[class*='van-hairline']::after {
    border: none;
}
.van-list {
    width: 345px;
}
</style>
